'use client'

import { RESOURCE_TYPE } from '@models'
import { useSearch } from '@utils/hooks'
import {
  ResourceSearchHitDocumentData,
  ResourceSearchResponse,
} from 'src/api/lead/search-engine'

type SearchResourcesPayload = {
  q: string
  count?: number
  resourceType?: RESOURCE_TYPE
}

type Props<T> = {
  enabled: boolean
  count?: number
  searchValue?: string
  resourceType?: RESOURCE_TYPE
  adapterFn: (data: ResourceSearchHitDocumentData) => T
}

/**
 * Searches resources via our internal API route (keeps Typesense API key server-side)
 */
async function searchResources(
  q: string,
  count: number,
  resourceType: RESOURCE_TYPE
): Promise<ResourceSearchResponse> {
  const payload: SearchResourcesPayload = { q, count, resourceType }

  const res = await fetch('/api/typesense-import/search-resource', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })

  if (!res.ok) {
    throw new Error('Search failed')
  }

  return res.json()
}

export const useResourcesSearchSiteFetch = <T>({
  enabled,
  count = 10,
  searchValue,
  resourceType = RESOURCE_TYPE.Blogs,
  adapterFn,
}: Props<T>) => {
  const search = useSearch({
    enabled,
    asyncFn: async (searchValue: string) => {
      const data = await searchResources(searchValue, count, resourceType)
      return data.results[0].hits.map((hit) => adapterFn(hit.document))
    },
    onSuccess: () => {},
    initialSearchValue: searchValue,
  })

  return { ...search }
}
